export const FETCHING_USER_DETAILS = 'FETCHING_USER_DETAILS';
export const SAVE_USER_DETAILS = 'SAVE_USER_DETAILS';
export const USER_DETAILS_FETCH_FAILED = 'USER_DETAILS_FETCH_FAILED';
export const SAVE_USER_DETAILS_FAIL= 'SAVE_USER_DETAILS_FAIL';